// US visa/work-authorization categories used in the Candidate Portal
// Dossier -- "Visa Type" dropdown. UAT-driven from Feb-2026 requirements.
export const VISA_TYPES = [
  "US Citizen",
  "Green Card (Permanent Resident)",
  "GC EAD",
  "H1B",
  "H1B (I-140 approved)",
  "H1B (I-140 approved, now B2)",
  "H4 EAD",
  "L1 (A / B)",
  "L2 EAD",
  "F1",
  "F1 Initial OPT",
  "F1 OPT",
  "F1 OPT EAD",
  "F1 STEM OPT",
  "F1 CPT",
  "F1 Day-1 CPT",
  "TN (USMCA)",
  "O-1",
  "E-3",
  "Asylum EAD",
  "Refugee EAD",
  "Other",
];

export const VISA_TYPE_OTHER = "Other";
